import React from 'react'
import * as Styles from './styles'
import Icon from '../../icon'

type Props = {
  collapsed: boolean
  onToggle: Function
  text?: string
}

const Toggler: React.FC<any> = (props: Props) => {
  const onClick = (): void => props.onToggle(!props.collapsed)

  return (
    <Styles.Toggler onClick={onClick}>
      <Styles.Container>
        <Styles.Icon className={props.collapsed ? '' : 'keyboard-left'}>
          <Icon name={'KeyboardTabOutlined'} />
        </Styles.Icon>
        <Styles.Text>{props.text}</Styles.Text>
      </Styles.Container>
    </Styles.Toggler>
  )
}

export default Toggler
